/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_SubInputs */

const en_mk_cmp_sub = /** @type {(inputs: Mk_Cmp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep does not replace your spec — it becomes its evidence gate. Plans come in and go out as your tool’s native files.`)
};

const id_mk_cmp_sub = /** @type {(inputs: Mk_Cmp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep bukan pengganti spec-mu — ia menjadi gerbang buktinya. Rencana masuk dan keluar sebagai berkas asli alatmu.`)
};

/**
* | output |
* | --- |
* | "Bystep does not replace your spec — it becomes its evidence gate. Plans come in and go out as your tool’s native files." |
*
* @param {Mk_Cmp_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_sub = /** @type {((inputs?: Mk_Cmp_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_sub(inputs)
	return en_mk_cmp_sub(inputs)
});